/* eslint-disable camelcase */
import { COCP, LEAD_DATA_STORAGE_KEY_NAME, LEAD_DATA_STORAGE_MODULE_NAME } from "../common/constants";
import { removeFromLocalStorage, setInLocalStorage } from "../utils/utility";
import { MobileType, Platform, ClickStreamPlatform } from "./constants";
const uuid = require("uuid");

const processMsisdn = {
	setMsisdn: (msisdn) => {
		if (msisdn) {
			sessionStorage.setItem("msisdn", msisdn);
		}
	},
	getMsisdn: () => {
		return sessionStorage.getItem("msisdn");
	},
};

export function generate_new_uuid(cookieName) {
	let dt = new Date().getTime();
	const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
		/[xy]/g,
		function (c) {
			const r = (dt + Math.random() * 16) % 16 | 0;
			dt = Math.floor(dt / 16);
			// eslint-disable-next-line
			return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
		}
	);

	let milliSeconds = 30 * 60 * 1000;
	let data;
	const userType = "NEW";

	if (cookieName === "cs_vid") {
		data = uuid;
		milliSeconds = 365 * 24 * 60 * 60 * 1000;
	} else if (cookieName === "cs_sid") {
		data = {
			uuid: uuid,
			userType: userType,
		};
		data = JSON.stringify(data);
		milliSeconds = 30 * 60 * 1000;
	}

	set_cs_cookie(cookieName, data, milliSeconds);

	return uuid;
}

export function set_cs_cookie(name, value, milliSeconds) {
	let expires = "";
	if (milliSeconds) {
		const date = new Date();
		date.setTime(date.getTime() + milliSeconds);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}

export const get_cs_sid = () => {
	let cs_sid = read_cookie("cs_sid", "JSON");
	if (cs_sid !== undefined && cs_sid !== null && cs_sid !== "") {
		cs_sid = cs_sid.uuid;
	} else {
		cs_sid = generate_new_uuid("cs_sid");
	}
	return cs_sid;
};

export function read_cookie(name, type) {
	let result = document.cookie.match(new RegExp(name + "=([^;]+)"));
	if (type === "JSON") result && (result = JSON.parse(result[1]));
	return result;
}

export const get_cs_vid = () => {
	let cs_vid = read_cookie("cs_vid", "STRING");
	if (cs_vid !== undefined && cs_vid !== null && cs_vid !== "") {
		cs_vid = cs_vid[1];
	} else {
		cs_vid = generate_new_uuid("cs_vid");
	}
	return cs_vid;
};

const webviewCheck = () => {
	if (window.MyAirtelAppReact || window.webkit) {
		return true;
	} else return false;
};

const isMobileApp = () => {
	return webviewCheck();
};

const isWeb = () => {
	return isBrowser() || !isMobileApp();
};

const isBrowser = () => {
	let iWeb = false;
	const userAgent = window.navigator?.userAgent.toLowerCase();
	const safari = /safari/.test(userAgent);
	const ios = /iphone|ipod|ipad/.test(userAgent);
	iWeb = ios ? safari : !userAgent.includes("wv");
	return iWeb;
};

const iosOrAndroid = () => {
	const userAgent = window.navigator?.userAgent.toLowerCase();
	const ios = /iphone|ipod|ipad/.test(userAgent);

	if (ios) {
		return MobileType.IOS;
	} else {
		return MobileType.ANDROID;
	}
};

const getPlatform = () => {
	if (isWeb()) {
		if (iosOrAndroid() === MobileType.IOS) return Platform.IOS_WAP;
		return Platform.ANDROID_WAP;
	}
	if (iosOrAndroid() === MobileType.IOS) return Platform.IOS;
	return Platform.ANDROID;
};

const getClickStreamPlatform = () => {
	if (isWeb()) {
		return ClickStreamPlatform.M_WEB;
	} else {
		return ClickStreamPlatform.WEB_VIEW;
	}
};

const tabView = {
	setTabView() {
		sessionStorage.setItem("tabView", "true");
	},
	isTabView() {
		const isTabView = sessionStorage.getItem("tabView");
		if (isTabView) {
			return true;
		}
		return false;
	},
};

const getQueryParam = (param) => {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams?.get(param);
};

const isNewApp = () => {
	if (window.ReactNativeWebView) {
		return true;
	} else {
		return false;
	}
};

const getCSSid = () => {
	let cssid = readCookie("cs_sid", "JSON");
	if (cssid !== undefined && cssid !== null && cssid !== "") {
		cssid = cssid.uuid;
	} else {
		cssid = generateNewUuid("cssid");
	}
	return cssid;
};

const getCSVid = () => {
	let csvid = readCookie("cs_vid", "STRING");
	if (csvid !== undefined && csvid !== null && csvid !== "") {
		csvid = csvid[1];
	} else {
		csvid = generateNewUuid("csvid");
	}
	return csvid;
};

const generateNewUuid = (cookieName) => {
	let dt = new Date().getTime();
	let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
		/[xy]/g,
		function (c) {
			const r = (dt + Math.random() * 16) % 16 | 0;
			dt = Math.floor(dt / 16);
			// eslint-disable-next-line
			return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
		}
	);
	// this condition  will be removed when omni widget is integrated; this is added for maintaning sassion id for feasibility component in analytics
	if (window?.MyAirtelAppReact?.getSessionID()) {
		uuid = window?.MyAirtelAppReact?.getSessionID();
	}

	let milliSeconds = 30 * 60 * 1000;
	let data;
	const userType = "NEW";

	if (cookieName === "cs_vid") {
		data = uuid;
		milliSeconds = 365 * 24 * 60 * 60 * 1000;
	} else if (cookieName === "cs_sid") {
		data = {
			uuid: uuid,
			userType: userType,
		};
		data = JSON.stringify(data);
		milliSeconds = 30 * 60 * 1000;
	}

	setCSCookie(cookieName, data, milliSeconds);

	return uuid;
};

const setCSCookie = (name, value, milliSeconds) => {
	let expires = "";
	if (milliSeconds) {
		const date = new Date();
		date.setTime(date.getTime() + milliSeconds);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
};

const readCookie = (name, type) => {
	let result = document.cookie.match(new RegExp(name + "=([^;]+)"));
	if (type === "JSON") result && (result = JSON.parse(result[1]));
	return result;
};

export const isMobile = () => {
	const mobileCheck = {
		Android() {
			return navigator?.userAgent?.match(/Android/i);
		},
		BlackBerry() {
			return navigator?.userAgent?.match(/BlackBerry/i);
		},
		iOS() {
			return navigator?.userAgent?.match(/iPhone/i);
		},
		Opera() {
			return navigator?.userAgent?.match(/Opera Mini/i);
		},
		Windows() {
			return navigator?.userAgent?.match(/IEMobile/i);
		},
		any() {
			return (
				mobileCheck.Android() ||
				mobileCheck.BlackBerry() ||
				mobileCheck.iOS() ||
				mobileCheck.Opera() ||
				mobileCheck.Windows()
			);
		},
	};
	return !!mobileCheck.any();
};

function msInterval(initialTime) {
	const loadDate = new Date().getTime();
	const loadInterval = loadDate - initialTime;
	return loadInterval + '';
}

function isCOCP(templateName) {
	if(templateName) {
		const tempName = templateName.toLowerCase();
		const value = tempName.indexOf("cocp");
		if(value === 0) {
			return true;
		}
	}
	return false;
}

function generateAndSaveInteractionId() {
	try {
		const uniqueId = uuid.v4();
		const fetchedLeadData = {
			id : uniqueId,
			requestId : uniqueId,
			lob : COCP
		}
		removeFromLocalStorage(LEAD_DATA_STORAGE_MODULE_NAME, LEAD_DATA_STORAGE_KEY_NAME);
		setInLocalStorage(
			LEAD_DATA_STORAGE_MODULE_NAME,
			LEAD_DATA_STORAGE_KEY_NAME,
			JSON.stringify(fetchedLeadData)
		);
		
	}
	catch(err) {
		console.log("Error in generating Lead Id" , err)
	}
	
}


export {
	iosOrAndroid,
	isBrowser,
	isWeb,
	getPlatform,
	getClickStreamPlatform,
	tabView,
	webviewCheck,
	isMobileApp,
	getQueryParam,
	isNewApp,
	generateNewUuid,
	setCSCookie,
	getCSVid,
	getCSSid,
	readCookie,
	processMsisdn,
	msInterval,
	generateAndSaveInteractionId,
	isCOCP
};
